import React from 'react'

export default function Footer() {
    return (
        <footer className="footer">
            <div className="content has-text-centered">
                <p className="is-size-7">
                <a className="has-text-grey" href="mailto: deform.website@gmail.com" target="_blank" rel="noopener noreferrer">
                <small>© 2020&nbsp;</small>&nbsp;|&nbsp;<strong className="is-size-7 footer-logo">&nbsp;DeForm&nbsp;</strong>&nbsp;|&nbsp;<small>&nbsp;Ujjawal Shrivastava</small>
                </a>
                </p>
            </div>
        </footer>
    )
}
